import { Component, Input, Output   } from '@angular/core'; 
import { NgxPaginationModule } from 'ngx-pagination';
import { AgencyService } from '../_Services/agency.service';
import { CommonService } from '../_Services/common.service';
import { Router, ActivatedRoute } from '@angular/router'; 



@Component({
  templateUrl: 'agency.component.html'
})
export class AgencyComponent {

    agencies = [];   

    p: any = 1; 

    paginator = []; 

    states = [];

    model: any = {state: ''};

	constructor(private agencyService: AgencyService, private commonService: CommonService) { }

    changeShape(shape){ 
        this.model.state = shape;
    } 

	pageChanged(page: Number) {
		this.p = page;
	    this.agencyService.getAgencies(page, this.model).subscribe(result => {
                console.log(result);
                this.agencies = result.data;
                this.paginator = result.paginator; 
            });
	}

	ngOnInit() {  
	    this.agencyService.getAgencies(this.p, null).subscribe(result => {
                console.log(result);
                this.agencies = result.data;
                this.paginator = result.paginator; 
            }); 

        this.commonService.getStates().subscribe(result => {
                console.log(result);
                this.states = result; 
            }); 
	}
}


// WEBPACK FOOTER //
// ./src/app/agencies/agency.component.ts